import * as echarts from 'echarts';
export default {
  name: 'BMap',
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  methods: {}
};